import { defineStore } from 'pinia';
import Cookies from 'js-cookie';

type State = {
  themeAuto: boolean;
  darkThemeEnabled: boolean;
};

export const useThemeStore = defineStore('themeStore', {
  state: (): State => {
    const darkTheme: string | undefined = Cookies.get('dark_theme_enabled');
    const auto: boolean = darkTheme === undefined;
    const darkEnabled: boolean = darkTheme ? darkTheme === 'true' : window.matchMedia('(prefers-color-scheme: dark)').matches;

    setDarkTheme(darkEnabled);

    return {
      themeAuto: auto,
      darkThemeEnabled: darkEnabled,
    };
  },
  getters: {},
  actions: {
    autoThemeChange() {
      const auto = !this.themeAuto;
      const enabled = window.matchMedia('(prefers-color-scheme: dark)').matches;

      this.themeAuto = auto;
      this.darkThemeEnabled = enabled;

      Cookies.set('dark_theme_enabled', `${enabled}`, { expires: 365 });

      if (auto) {
        Cookies.remove('dark_theme_enabled');
      }
      setDarkTheme(enabled);
    },
    themeChange() {
      const enabled = !this.darkThemeEnabled;

      this.themeAuto = false;
      this.darkThemeEnabled = enabled;

      Cookies.set('dark_theme_enabled', `${enabled}`, { expires: 365 });
      setDarkTheme(enabled);
    },
    eventThemeChanging(isSystemThemeDark: boolean) {
      if (this.themeAuto) {
        this.darkThemeEnabled = isSystemThemeDark;
        setDarkTheme(isSystemThemeDark);
      }
    },
  },
});

export function setDarkTheme(darkThemeEnabled: boolean) {
  const el: HTMLMetaElement | null = document.querySelector("meta[name='theme-color']");

  if (darkThemeEnabled) {
    document.body.classList.add('dark');
    if (el) {
      el.content = '#000';
    }
  } else {
    document.body.classList.remove('dark');
    if (el) {
      el.content = '#FBFBFB';
    }
  }
}
